/**
 * Returns a list of words that look like passive verbs starting in `di`.
 *
 * @returns {string[]} Indonesian words that look like passive verbs starting in `di`.
 */
export default function() {
	return [
		"diskontinuitas",
		"diskualifikasi",
		"diskriminatif",
		"diskriminator",
		"digitalisasi",
		"disinformasi",
		"disintegrasi",
		"diskriminasi",
		"disorientasi",
		"distabilitas",
		"diktatorial",
		"disinfektan",
		"disinsentif",
		"diskrepansi",
		"distributor",
		"diagnostik",
		"dialketika",
		"diktatoris",
		"dinosaurus",
		"diplomatik",
		"diplomatis",
		"direktorat",
		"dirgantara",
		"disimilasi",
		"diskontinu",
		"diskulpasi",
		"disparitas",
		"dispensasi",
		"distilator",
		"distingtif",
		"distribusi",
		"diversitas",
		"diafragma",
		"diagnosis",
		"diakritik",
		"diakronis",
		"dialektal",
		"dialektik",
		"dialektis",
		"digenesis",
		"digitalis",
		"dilematik",
		"diminutif",
		"dinamisme",
		"dingklang",
		"diplomasi",
		"dirgahayu",
		"disertasi",
		"disfungsi",
		"diskredit",
		"diskursif",
		"disleksia",
		"dislokasi",
		"dismutasi",
		"disonansi",
		"disosiasi",
		"dispenser",
		"disposisi",
		"distilasi",
		"distingsi",
		"divestasi",
		"diabeter",
		"diagonal",
		"dialisis",
		"diameter",
		"diaspora",
		"difraksi",
		"digestif",
		"diglosia",
		"dikotomi",
		"diktator",
		"dilatasi",
		"dimorfik",
		"dinamika",
		"dioksida",
		"diopsida",
		"diplomat",
		"direktur",
		"disentri",
		"disensus",
		"disiplin",
		"diskotek",
		"diskresi",
		"dispersi",
		"disrupsi",
		"distansi",
		"distorsi",
		"diagram",
		"difabel",
		"digdaya",
		"digital",
		"digresi",
		"diletan",
		"dimensi",
		"dinamik",
		"dinamis",
		"dinamit",
		"dinasti",
		"dioksin",
		"diorama",
		"diploma",
		"diptera",
		"direksi",
		"dirigen",
		"disagio",
		"disiden",
		"disjoki",
		"diskoid",
		"diskusi",
		"disuasi",
		"dividen",
		"diadem",
		"diakon",
		"dialek",
		"dialog",
		"diaper",
		"diayah",
		"diesel",
		"dilasi",
		"dinamo",
		"diniah",
		"diorit",
		"diare",
		"diode",
		"didih",
		"didik",
		"didis",
		"digit",
		"dikau",
		"dikir",
		"diksi",
		"dikte",
		"dinas",
		"dipan",
		"dirah",
		"direk",
		"disko",
		"dinda",
		"difusi",
		"dilema",
		"dingin",
		"diniah",
		"diorit",
		"dirham",
		"disket",
		"diskon",
		"divisi",
		"diftong",
		"difteri",
		"dinding",
		"dingkis",
		"dingkit",
		"dioksin",
		"diorama",
		"diploma",
		"dirigen",
		"disiden",
		"displin",
		"disjoki",
		"diskusi",
		"distrik",
		"dividen",
		"digestif",
		"diglosia",
		"dikotomi",
		"dingklik",
		"dioksida",
		"diplomat",
		"direktur",
		"disentri",
		"diskresi",
		"disorder",
		"dispersi",
		"distansi",
		"disrupsi",
		"divergen",
		"dingklang",
		"diplomasi",
		"dirgahayu",
		"disertasi",
		"disfungsi",
		"disilabik",
		"diskredit",
		"disleksia",
		"dislokasi",
		"disosiasi",
		"dispenser",
		"disposisi",
		"distilasi",
		"dinosaurus",
		"diplomatik",
		"diplomatis",
		"dirgantara",
		"disimilasi",
		"diskontinu",
		"disparitas",
		"distilator",
		"distribusi",
		"divergensi",
		"diversitas",
		"disabilitas",
		"disinfektan",
		"diskrepansi",
		"disintegrasi",
		"diskriminasi",
		"diskriminatif",
		"diskontinuitas",
		"diskualifikasi",
	];
}
